/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from 'theme-ui';
import { ReactElement } from 'react';
import Link from 'next/link';

interface Props {
  users: Array<any>;
  count?: number;
}

const UserAvatars = ({ users, count }: Props): ReactElement => {
  return (
    <div
      sx={{
        position: 'relative',
        display: 'flex',
        '>div': {
          height: '50px',
          width: '50px',
          backgroundColor: 'textWhite',
          backgroundRepeat: 'no-repeat',
          backgroundSize: 'cover',
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          borderWidth: '1px',
          borderColor: 'primary',
          borderStyle: 'solid',
          borderRadius: '50%',
          marginLeft: '-10px',
          color: 'primary',
        },
      }}
    >
      {users.slice(0, 5).map((item) => (
        <Link
          key={item?.user?.username || item?.username}
          href={`/authors/${item?.user?.username || item?.username}`}
        >
          <div
            sx={{
              backgroundImage: `url("${
                item?.user?.avatarUrl || item?.avatarUrl
              }")`,
              cursor: 'pointer',
            }}
          />
        </Link>
      ))}

      <div sx={{ backgroundImage: 'none' }}>{count || users.length}</div>
    </div>
  );
};

export default UserAvatars;
